export default __webpack_public_path__ + "static/media/weblink.d68c8fb5.svg";